import axios from 'axios';

export default axios.create({
  baseURL: `${process.env.REACT_APP_API_ENDPOINT}/api/state-contestant`,
  timeout: Number(process.env.REACT_APP_DEFAULT_REQUEST_TIMEOUT),
});
